export default [
  { 
    path: '/about', 
    name: 'AboutList', 
    component: () => import('@/views/about/List'),
    meta: {
      breadcrumbs: [
        { text: 'เกี่ยวกับกองบริหารงานบุคคล', disabled: true }
      ]
    }
  },
  { 
    path: '/about/:id/edit', 
    name: 'AboutEdit', 
    component: () => import('@/views/about/Form'),
    meta: {
      form_type: 'EDIT', 
      form_title: 'แก้ไข',
      breadcrumbs: [
        { text: 'เกี่ยวกับ', to: `/about` },
        { text: 'แก้ไข' },
      ]
    }
  },
]